import { createFileRoute } from "@tanstack/react-router";
import ImportLanding from "@/pages/ImportLanding";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/import/")({
  head: () => routeHead("/uk/import/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ImportLanding />
  );
}
